'use client';

import React, { useRef } from 'react';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import { Lottie, LottieComponentProps } from '@/components/LottieWrapper';
import { useGSAP } from '@gsap/react';
import { LottieRefCurrentProps } from 'lottie-react';

export interface LottieOnScrollProps {
  animationData: LottieComponentProps['animationData'];
  className?: string;
  delay?: number;
}

//** Will play animation when it comes into view */
export function LottieOnScroll({ animationData, className, delay = 0.2 }: LottieOnScrollProps) {
  const lottieRef = useRef<LottieRefCurrentProps>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const playedRef = useRef(false);

  useGSAP(() => {
    gsap.registerPlugin(ScrollTrigger);

    ScrollTrigger.create({
      trigger: containerRef.current,
      start: 'top center+=20%',
      end: 'bottom center',
      onEnter: () => {
        // only play the animation once
        if (lottieRef.current && !playedRef.current) {
          gsap
            .timeline()
            .to({}, { duration: delay })
            .add(() => {
              lottieRef.current?.play();
              playedRef.current = true;
            });
        }
      },
    });
  });

  return (
    <div ref={containerRef} className={className}>
      <Lottie animationData={animationData} loop={false} autoplay={false} lottieRef={lottieRef} />
    </div>
  );
}
